//#region src/resources/conversation-inspector/ConversationInspectorResource.mocks.ts
var e = 400, t = (t, n = e) => new Promise((e) => {
	setTimeout(() => e(t), n);
}), n = (t, n = e) => new Promise((e, r) => {
	setTimeout(() => r(t), n);
}), r = {
	errorCode: "KNOWLEDGE:CONVERSATION_NOT_FOUND",
	message: "Conversation 'conv_123' not found.",
	requestId: "4d6da40c-19fc-459b-a39b-9a6ba0311448"
}, i = {
	errorCode: "KNOWLEDGE:CONVERSATION_NOT_DEBUG",
	message: "Conversation 'conv_1234' was not recorded in debug mode.",
	requestId: "5e7eb51d-20fd-460c-b40c-0b7cb1412559"
}, a = (e) => e === "conv_123" ? n(r) : e === "conv_1234" ? n(i) : t({
	conversationId: e,
	organizationId: "my-org-id",
	setup: {
		passageRetrievalModel: "Coveo Relevance Generative Answering",
		agent: "Support Agent",
		searchHub: "default"
	},
	turns: [
		{
			turnNumber: 1,
			query: "How do I set up content security policies?",
			answer: "## Setting Up Content Security Policies\n\nTo configure content security policies (CSP) in your Coveo organization, follow these steps:\n\n1. Navigate to **Organization Settings** > **Security**.\n2. Under the **Content Security Policy** section, click **Add directive**.\n3. Specify the directive type (e.g., `script-src`, `style-src`) and the allowed sources.\n4. Click **Save** to apply the changes.\n\n> **Note:** Changes to CSP directives may take up to 15 minutes to propagate across all endpoints.\n\nFor more details, refer to the [Content Security Policy documentation](https://docs.coveo.com/en/csp).",
			retrievedPassages: [
				{
					passageId: "passage-001",
					primaryId: "doc-security-policies-001",
					passageScore: .92,
					title: "Configuring Content Security Policies",
					text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
					uri: "https://docs.coveo.com/en/content-security-policies",
					clickUri: "https://docs.coveo.com/en/content-security-policies",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-002",
					primaryId: "doc-security-overview-002",
					passageScore: .85,
					title: "Security Overview",
					text: "Coveo provides multiple layers of security including content security policies, search token authentication, and privilege-based access control. Each layer can be configured independently to match your organization requirements.",
					uri: "https://docs.coveo.com/en/security-overview",
					clickUri: "https://docs.coveo.com/en/security-overview",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-003",
					primaryId: "doc-csp-directives-003",
					passageScore: .78,
					title: "CSP Directive Reference",
					text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
					uri: "https://docs.coveo.com/en/csp-directives",
					clickUri: "https://docs.coveo.com/en/csp-directives",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-004",
					primaryId: "doc-troubleshooting-004",
					passageScore: .61,
					title: "Troubleshooting CSP Violations",
					text: "If you encounter CSP violation errors in the browser console, check that all required domains are included in your CSP directives. Common issues include missing CDN domains for Coveo JavaScript libraries and missing API endpoint domains.",
					uri: "https://docs.coveo.com/en/csp-troubleshooting",
					clickUri: "https://docs.coveo.com/en/csp-troubleshooting",
					source: "Coveo Documentation"
				}
			],
			citedPassages: [{
				passageId: "passage-001",
				primaryId: "doc-security-policies-001",
				passageScore: .92,
				title: "Configuring Content Security Policies",
				text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
				uri: "https://docs.coveo.com/en/content-security-policies",
				clickUri: "https://docs.coveo.com/en/content-security-policies",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-003",
				primaryId: "doc-csp-directives-003",
				passageScore: .78,
				title: "CSP Directive Reference",
				text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
				uri: "https://docs.coveo.com/en/csp-directives",
				clickUri: "https://docs.coveo.com/en/csp-directives",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 2,
			query: "What are the supported CSP directive types?",
			answer: "The supported CSP directive types are:\n\n- `script-src` — Controls which scripts can be executed\n- `style-src` — Controls which stylesheets can be applied\n- `img-src` — Controls which images can be loaded\n- `font-src` — Controls which fonts can be loaded\n- `connect-src` — Controls which URLs can be accessed via fetch/XHR\n- `frame-src` — Controls which URLs can be embedded in frames\n\nEach directive accepts a list of allowed sources including `self`, specific domains, and nonce-based values.",
			retrievedPassages: [{
				passageId: "passage-005",
				primaryId: "doc-csp-directives-003",
				passageScore: .95,
				title: "CSP Directive Reference",
				text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
				uri: "https://docs.coveo.com/en/csp-directives",
				clickUri: "https://docs.coveo.com/en/csp-directives",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-006",
				primaryId: "doc-csp-advanced-005",
				passageScore: .72,
				title: "Advanced CSP Configuration",
				text: "For advanced use cases, you can combine multiple directives and use wildcard patterns. The default-src directive serves as a fallback for any directive not explicitly specified.",
				uri: "https://docs.coveo.com/en/csp-advanced",
				clickUri: "https://docs.coveo.com/en/csp-advanced",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-005",
				primaryId: "doc-csp-directives-003",
				passageScore: .95,
				title: "CSP Directive Reference",
				text: "The following CSP directives are supported: script-src, style-src, img-src, font-src, connect-src, frame-src. Each directive accepts a list of allowed sources including self, specific domains, and nonce-based values.",
				uri: "https://docs.coveo.com/en/csp-directives",
				clickUri: "https://docs.coveo.com/en/csp-directives",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-001",
				primaryId: "doc-security-policies-001",
				passageScore: .92,
				title: "Configuring Content Security Policies",
				text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
				uri: "https://docs.coveo.com/en/content-security-policies",
				clickUri: "https://docs.coveo.com/en/content-security-policies",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 3,
			query: "Can I use wildcards in CSP sources?",
			answer: null,
			retrievedPassages: [],
			citedPassages: null
		},
		{
			turnNumber: 4,
			query: "How long does it take for CSP changes to propagate?",
			answer: "Changes to CSP directives may take up to **15 minutes** to propagate across all endpoints. During this propagation period, some requests may still be evaluated against the previous policy.",
			retrievedPassages: [{
				passageId: "passage-008",
				primaryId: "doc-security-policies-001",
				passageScore: .88,
				title: "Configuring Content Security Policies",
				text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
				uri: "https://docs.coveo.com/en/content-security-policies",
				clickUri: "https://docs.coveo.com/en/content-security-policies",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-008",
				primaryId: "doc-security-policies-001",
				passageScore: .88,
				title: "Configuring Content Security Policies",
				text: "Content Security Policies (CSP) help prevent cross-site scripting attacks by specifying which sources of content are allowed to be loaded. To configure CSP in your Coveo organization, navigate to Organization Settings > Security and add the appropriate directives.",
				uri: "https://docs.coveo.com/en/content-security-policies",
				clickUri: "https://docs.coveo.com/en/content-security-policies",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 5,
			query: "I have a complex multi-tenant architecture where each tenant has its own set of allowed domains for script loading, style injection, image hosting, and API connectivity, and I need to understand how to configure content security policies at both the organization level and the individual search hub level so that each tenant gets the correct CSP headers without interfering with other tenants or breaking the shared components that are loaded from our central CDN — is there a recommended approach for this kind of setup?",
			answer: "## Multi-Tenant CSP Configuration\n\nFor multi-tenant architectures, the recommended approach is:\n\n1. **Organization-level base policy** — Define a base CSP at the organization level that includes shared resources (central CDN, common API endpoints).\n2. **Search hub overrides** — Use search hub-specific CSP overrides to add tenant-specific domains on top of the base policy.\n3. **Inheritance model** — Search hub policies inherit from the organization policy by default. You can extend but not restrict the base policy at the hub level.\n\n### Example Configuration\n\n```\n# Organization base\nscript-src: self cdn.company.com\nconnect-src: self api.coveo.com\n\n# Tenant A search hub override\nscript-src: self cdn.company.com tenant-a.assets.com\nimg-src: self tenant-a.images.com\n\n# Tenant B search hub override\nscript-src: self cdn.company.com tenant-b.cdn.net\nimg-src: self media.tenant-b.org\n```\n\n> **Important:** Always test CSP changes in a staging environment before applying them to production tenants.",
			retrievedPassages: [
				{
					passageId: "passage-009",
					primaryId: "doc-multi-tenant-csp-006",
					passageScore: .94,
					title: "Multi-Tenant CSP Strategies",
					text: "When operating in a multi-tenant environment, CSP configurations can be layered. The organization-level policy serves as a base, and individual search hubs can extend it with additional allowed sources. This ensures shared components remain functional while tenant-specific resources are properly whitelisted.",
					uri: "https://docs.coveo.com/en/multi-tenant-csp",
					clickUri: "https://docs.coveo.com/en/multi-tenant-csp",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-010",
					primaryId: "doc-search-hub-config-007",
					passageScore: .89,
					title: "Search Hub Configuration",
					text: "Search hubs can be configured with their own security policies that extend the organization-level settings. This includes CSP directives, allowed origins for CORS, and authentication requirements.",
					uri: "https://docs.coveo.com/en/search-hub-configuration",
					clickUri: "https://docs.coveo.com/en/search-hub-configuration",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-011",
					primaryId: "doc-csp-inheritance-008",
					passageScore: .84,
					title: "CSP Policy Inheritance",
					text: "CSP policies follow an inheritance model where child configurations extend parent policies. A search hub policy cannot be more restrictive than its parent organization policy, but it can add additional allowed sources.",
					uri: "https://docs.coveo.com/en/csp-inheritance",
					clickUri: "https://docs.coveo.com/en/csp-inheritance",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-012",
					primaryId: "doc-csp-testing-009",
					passageScore: .77,
					title: "Testing CSP Changes",
					text: "Before deploying CSP changes to production, use the Content-Security-Policy-Report-Only header to test your policies. This allows you to identify violations without blocking content, ensuring a smooth rollout.",
					uri: "https://docs.coveo.com/en/csp-testing",
					clickUri: "https://docs.coveo.com/en/csp-testing",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-013",
					primaryId: "doc-cdn-integration-010",
					passageScore: .71,
					title: "CDN Integration and CSP",
					text: "When using a central CDN for shared components, ensure the CDN domain is included in the base organization CSP. Common CDN patterns include versioned paths and content-hash URLs that remain stable across deployments.",
					uri: "https://docs.coveo.com/en/cdn-csp-integration",
					clickUri: "https://docs.coveo.com/en/cdn-csp-integration",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-014",
					primaryId: "doc-tenant-isolation-011",
					passageScore: .65,
					title: "Tenant Isolation Best Practices",
					text: "Ensure proper tenant isolation by using separate search hubs per tenant. Each hub should have its own analytics, CSP configuration, and query pipeline to prevent data leakage between tenants.",
					uri: "https://docs.coveo.com/en/tenant-isolation",
					clickUri: "https://docs.coveo.com/en/tenant-isolation",
					source: "Coveo Documentation"
				}
			],
			citedPassages: [
				{
					passageId: "passage-009",
					primaryId: "doc-multi-tenant-csp-006",
					passageScore: .94,
					title: "Multi-Tenant CSP Strategies",
					text: "When operating in a multi-tenant environment, CSP configurations can be layered. The organization-level policy serves as a base, and individual search hubs can extend it with additional allowed sources. This ensures shared components remain functional while tenant-specific resources are properly whitelisted.",
					uri: "https://docs.coveo.com/en/multi-tenant-csp",
					clickUri: "https://docs.coveo.com/en/multi-tenant-csp",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-010",
					primaryId: "doc-search-hub-config-007",
					passageScore: .89,
					title: "Search Hub Configuration",
					text: "Search hubs can be configured with their own security policies that extend the organization-level settings. This includes CSP directives, allowed origins for CORS, and authentication requirements.",
					uri: "https://docs.coveo.com/en/search-hub-configuration",
					clickUri: "https://docs.coveo.com/en/search-hub-configuration",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-011",
					primaryId: "doc-csp-inheritance-008",
					passageScore: .84,
					title: "CSP Policy Inheritance",
					text: "CSP policies follow an inheritance model where child configurations extend parent policies. A search hub policy cannot be more restrictive than its parent organization policy, but it can add additional allowed sources.",
					uri: "https://docs.coveo.com/en/csp-inheritance",
					clickUri: "https://docs.coveo.com/en/csp-inheritance",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-012",
					primaryId: "doc-csp-testing-009",
					passageScore: .77,
					title: "Testing CSP Changes",
					text: "Before deploying CSP changes to production, use the Content-Security-Policy-Report-Only header to test your policies. This allows you to identify violations without blocking content, ensuring a smooth rollout.",
					uri: "https://docs.coveo.com/en/csp-testing",
					clickUri: "https://docs.coveo.com/en/csp-testing",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-013",
					primaryId: "doc-cdn-integration-010",
					passageScore: .71,
					title: "CDN Integration and CSP",
					text: "When using a central CDN for shared components, ensure the CDN domain is included in the base organization CSP. Common CDN patterns include versioned paths and content-hash URLs that remain stable across deployments.",
					uri: "https://docs.coveo.com/en/cdn-csp-integration",
					clickUri: "https://docs.coveo.com/en/cdn-csp-integration",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-014",
					primaryId: "doc-tenant-isolation-011",
					passageScore: .65,
					title: "Tenant Isolation Best Practices",
					text: "Ensure proper tenant isolation by using separate search hubs per tenant. Each hub should have its own analytics, CSP configuration, and query pipeline to prevent data leakage between tenants.",
					uri: "https://docs.coveo.com/en/tenant-isolation",
					clickUri: "https://docs.coveo.com/en/tenant-isolation",
					source: "Coveo Documentation"
				}
			]
		},
		{
			turnNumber: 6,
			query: "Does CSP affect Coveo Headless?",
			answer: "Yes, CSP can affect **Coveo Headless** if your policy restricts `connect-src`. Headless makes API calls to:\n\n- `platform.cloud.coveo.com` (or your regional endpoint)\n- `analytics.cloud.coveo.com`\n- `search.cloud.coveo.com`\n\nEnsure these domains are included in your `connect-src` directive. Since Headless is a JavaScript library, the `script-src` directive must also allow the source from which it is loaded (typically your CDN or bundled assets).",
			retrievedPassages: [{
				passageId: "passage-015",
				primaryId: "doc-headless-csp-012",
				passageScore: .91,
				title: "Coveo Headless and CSP Requirements",
				text: "Coveo Headless requires connect-src to include platform.cloud.coveo.com and analytics.cloud.coveo.com. Without these, API requests will be blocked by the browser CSP enforcement.",
				uri: "https://docs.coveo.com/en/headless-csp",
				clickUri: "https://docs.coveo.com/en/headless-csp",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-016",
				primaryId: "doc-headless-setup-013",
				passageScore: .74,
				title: "Getting Started with Coveo Headless",
				text: "Coveo Headless is a framework-agnostic library that provides state management and API communication for building search experiences. It handles query execution, facets, pagination, and analytics out of the box.",
				uri: "https://docs.coveo.com/en/headless-getting-started",
				clickUri: "https://docs.coveo.com/en/headless-getting-started",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-015",
				primaryId: "doc-headless-csp-012",
				passageScore: .91,
				title: "Coveo Headless and CSP Requirements",
				text: "Coveo Headless requires connect-src to include platform.cloud.coveo.com and analytics.cloud.coveo.com. Without these, API requests will be blocked by the browser CSP enforcement.",
				uri: "https://docs.coveo.com/en/headless-csp",
				clickUri: "https://docs.coveo.com/en/headless-csp",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 7,
			query: "What about Coveo Atomic components?",
			answer: "For **Coveo Atomic** components, you need the same `connect-src` domains as Headless, plus:\n\n- `style-src` must allow `unsafe-inline` or use a nonce, since Atomic injects component styles dynamically\n- `img-src` must allow the domains hosting your result thumbnails and icons\n- `font-src` should include any custom font CDNs used in your theme\n\nThe Atomic documentation provides a complete list of required CSP directives for each component variant.",
			retrievedPassages: [{
				passageId: "passage-017",
				primaryId: "doc-atomic-csp-014",
				passageScore: .93,
				title: "Atomic Components CSP Requirements",
				text: "Coveo Atomic web components inject styles dynamically, requiring style-src unsafe-inline or a nonce-based approach. Additionally, img-src must cover thumbnail domains and font-src must include font CDN origins.",
				uri: "https://docs.coveo.com/en/atomic-csp",
				clickUri: "https://docs.coveo.com/en/atomic-csp",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-018",
				primaryId: "doc-atomic-theming-015",
				passageScore: .68,
				title: "Theming Atomic Components",
				text: "Atomic components support CSS custom properties for theming. Fonts, colors, and spacing can be customized through CSS variables without requiring additional CSP exceptions.",
				uri: "https://docs.coveo.com/en/atomic-theming",
				clickUri: "https://docs.coveo.com/en/atomic-theming",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-017",
				primaryId: "doc-atomic-csp-014",
				passageScore: .93,
				title: "Atomic Components CSP Requirements",
				text: "Coveo Atomic web components inject styles dynamically, requiring style-src unsafe-inline or a nonce-based approach. Additionally, img-src must cover thumbnail domains and font-src must include font CDN origins.",
				uri: "https://docs.coveo.com/en/atomic-csp",
				clickUri: "https://docs.coveo.com/en/atomic-csp",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 8,
			query: "How do I debug CSP violations in production?",
			answer: "To debug CSP violations in production:\n\n1. **Enable report-only mode** — Use the `Content-Security-Policy-Report-Only` header to log violations without blocking content.\n2. **Set up a reporting endpoint** — Configure `report-uri` or `report-to` directives to collect violation reports.\n3. **Check browser console** — CSP violations are logged in the browser developer console with details about the blocked resource.\n4. **Use the Coveo Admin Console** — Navigate to **Organization** > **Security** > **CSP Reports** to view aggregated violation data.\n\n### Common Violation Patterns\n\n| Violation | Likely Cause |\n|---|---|\n| `script-src` blocked | Missing CDN or third-party script domain |\n| `connect-src` blocked | Missing API endpoint domain |\n| `style-src` blocked | Inline styles without nonce |\n| `img-src` blocked | Dynamic image URLs from search results |",
			retrievedPassages: [
				{
					passageId: "passage-019",
					primaryId: "doc-csp-debugging-016",
					passageScore: .96,
					title: "Debugging CSP Violations",
					text: "Use the Content-Security-Policy-Report-Only header to test policies without enforcement. Configure report-uri to collect violation data. The browser console will display detailed violation messages including the blocked URI and the directive that was violated.",
					uri: "https://docs.coveo.com/en/csp-debugging",
					clickUri: "https://docs.coveo.com/en/csp-debugging",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-020",
					primaryId: "doc-csp-reports-017",
					passageScore: .82,
					title: "CSP Violation Reports",
					text: "CSP violation reports include the document URI, the violated directive, the blocked URI, and the disposition (enforce or report). These reports can be aggregated to identify patterns and prioritize fixes.",
					uri: "https://docs.coveo.com/en/csp-reports",
					clickUri: "https://docs.coveo.com/en/csp-reports",
					source: "Coveo Documentation"
				},
				{
					passageId: "passage-021",
					primaryId: "doc-troubleshooting-004",
					passageScore: .73,
					title: "Troubleshooting CSP Violations",
					text: "If you encounter CSP violation errors in the browser console, check that all required domains are included in your CSP directives. Common issues include missing CDN domains for Coveo JavaScript libraries and missing API endpoint domains.",
					uri: "https://docs.coveo.com/en/csp-troubleshooting",
					clickUri: "https://docs.coveo.com/en/csp-troubleshooting",
					source: "Coveo Documentation"
				}
			],
			citedPassages: [{
				passageId: "passage-019",
				primaryId: "doc-csp-debugging-016",
				passageScore: .96,
				title: "Debugging CSP Violations",
				text: "Use the Content-Security-Policy-Report-Only header to test policies without enforcement. Configure report-uri to collect violation data. The browser console will display detailed violation messages including the blocked URI and the directive that was violated.",
				uri: "https://docs.coveo.com/en/csp-debugging",
				clickUri: "https://docs.coveo.com/en/csp-debugging",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-020",
				primaryId: "doc-csp-reports-017",
				passageScore: .82,
				title: "CSP Violation Reports",
				text: "CSP violation reports include the document URI, the violated directive, the blocked URI, and the disposition (enforce or report). These reports can be aggregated to identify patterns and prioritize fixes.",
				uri: "https://docs.coveo.com/en/csp-reports",
				clickUri: "https://docs.coveo.com/en/csp-reports",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 9,
			query: "Can I use nonces instead of unsafe-inline?",
			answer: "Yes, **nonces are the recommended approach** over `unsafe-inline` for production environments.\n\nTo use nonces with Coveo Atomic:\n\n1. Generate a unique nonce on each page load (server-side)\n2. Pass the nonce to the Atomic initialization:\n   ```javascript\n   const engine = buildSearchEngine({\n     configuration: {\n       cspNonce: 'abc123'\n     }\n   });\n   ```\n3. Include the nonce in your CSP header:\n   ```\n   style-src 'nonce-abc123';\n   script-src 'nonce-abc123';\n   ```\n\nThis approach provides better security than `unsafe-inline` while allowing Atomic to inject its required styles.",
			retrievedPassages: [{
				passageId: "passage-022",
				primaryId: "doc-csp-nonces-018",
				passageScore: .97,
				title: "Using Nonces with Coveo",
				text: "Nonces provide a more secure alternative to unsafe-inline. Generate a unique nonce server-side for each page load and pass it to both the CSP header and the Coveo engine configuration. This allows legitimate inline styles while blocking injected content.",
				uri: "https://docs.coveo.com/en/csp-nonces",
				clickUri: "https://docs.coveo.com/en/csp-nonces",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-023",
				primaryId: "doc-atomic-security-019",
				passageScore: .79,
				title: "Atomic Security Best Practices",
				text: "When deploying Atomic components in security-sensitive environments, prefer nonces over unsafe-inline, use subresource integrity (SRI) for script loading, and implement strict transport security headers.",
				uri: "https://docs.coveo.com/en/atomic-security",
				clickUri: "https://docs.coveo.com/en/atomic-security",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-022",
				primaryId: "doc-csp-nonces-018",
				passageScore: .97,
				title: "Using Nonces with Coveo",
				text: "Nonces provide a more secure alternative to unsafe-inline. Generate a unique nonce server-side for each page load and pass it to both the CSP header and the Coveo engine configuration. This allows legitimate inline styles while blocking injected content.",
				uri: "https://docs.coveo.com/en/csp-nonces",
				clickUri: "https://docs.coveo.com/en/csp-nonces",
				source: "Coveo Documentation"
			}, {
				passageId: "passage-023",
				primaryId: "doc-atomic-security-019",
				passageScore: .79,
				title: "Atomic Security Best Practices",
				text: "When deploying Atomic components in security-sensitive environments, prefer nonces over unsafe-inline, use subresource integrity (SRI) for script loading, and implement strict transport security headers.",
				uri: "https://docs.coveo.com/en/atomic-security",
				clickUri: "https://docs.coveo.com/en/atomic-security",
				source: "Coveo Documentation"
			}]
		},
		{
			turnNumber: 10,
			query: "Are there any known limitations?",
			answer: "There are a few known limitations with CSP in Coveo:\n\n- **Report-only mode** is not supported at the search hub level — it only works at the organization level\n- **Wildcard subdomains** (e.g., `*.example.com`) count as a single source entry but may have performance implications with many subdomains\n- **Hot-reloading in development** requires `unsafe-eval` in `script-src`, which should never be used in production\n- **Legacy browsers** (IE11) do not fully support CSP Level 2 directives such as `nonce` and `hash`\n- **Maximum directive length** is 2048 characters per directive — exceeding this will cause the directive to be silently truncated",
			retrievedPassages: [{
				passageId: "passage-024",
				primaryId: "doc-csp-limitations-020",
				passageScore: .9,
				title: "CSP Limitations and Known Issues",
				text: "Known limitations include: report-only mode only at org level, wildcard subdomain performance considerations, maximum directive length of 2048 characters, and limited legacy browser support for CSP Level 2 features.",
				uri: "https://docs.coveo.com/en/csp-limitations",
				clickUri: "https://docs.coveo.com/en/csp-limitations",
				source: "Coveo Documentation"
			}],
			citedPassages: [{
				passageId: "passage-024",
				primaryId: "doc-csp-limitations-020",
				passageScore: .9,
				title: "CSP Limitations and Known Issues",
				text: "Known limitations include: report-only mode only at org level, wildcard subdomain performance considerations, maximum directive length of 2048 characters, and limited legacy browser support for CSP Level 2 features.",
				uri: "https://docs.coveo.com/en/csp-limitations",
				clickUri: "https://docs.coveo.com/en/csp-limitations",
				source: "Coveo Documentation"
			}]
		}
	]
});
//#endregion
export { a as createMockConversationDebugResponse };

//# sourceMappingURL=ConversationInspectorResource.mocks.js.map